import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { ErrorBoundary } from '@/components/common/error-boundary'
import { Skeleton } from '@/components/ui/skeleton'

const DetailsAutomation = lazy(() =>
	import('@/features/air/case-management/components/details/automation').then(
		(m) => ({ default: m.DetailsAutomation }),
	),
)

export const Route = createFileRoute(
	'/_dashboard/air/case-management/$id/automation',
)({
	head: ({ params }) => ({
		meta: [
			{
				title: `Automation · Case ${params.id} | Case Management | BitLyft AIR®`,
			},
		],
	}),
	component: RouteComponent,
})

function RouteComponent() {
	const { id } = Route.useParams()

	return (
		<ErrorBoundary feature="case-management" section="automation" entityId={id}>
			<Suspense fallback={<Skeleton className="h-48 w-full" />}>
				<DetailsAutomation id={id} />
			</Suspense>
		</ErrorBoundary>
	)
}
